export default function Selection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const process = [
    { step: '01', title: '書面申請', description: '提交申請表與相關資料' },
    { step: '02', title: '推薦人評估', description: '由推薦人提供評估意見' },
    { step: '03', title: '面談評選', description: '與評審團進行深度面談' },
    { step: '04', title: '社會影響潛力評估', description: '評估未來回饋社會的可能性' }
  ];

  const reviewers = [
    '教育工作者',
    '公益組織代表',
    '企業代表',
    '青年發展專家',
    '校友與社會領袖'
  ];

  return (
    <section id="selection" className="relative py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e78b75901c678b3c9bd86ade5bb0d977.jpg"
          alt="評選機制"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="flex flex-col justify-between min-h-[500px]">
          <div>
            <h2 className="text-7xl font-bold text-white leading-tight mb-4">
              公平<br />
              透明<br />
              多元
            </h2>
          </div>

          <div className="flex items-end justify-between">
            <button
              onClick={() => scrollToSection('application')}
              className="group flex items-center gap-3 bg-white rounded-full pl-6 pr-2 py-2 hover:shadow-lg transition-all cursor-pointer whitespace-nowrap"
            >
              <span className="text-sm font-medium text-gray-900">查看評選流程</span>
              <div className="w-10 h-10 bg-black rounded-full flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-lg"></i>
              </div>
            </button>

            <div className="text-right max-w-md">
              <p className="text-xl text-white font-light leading-relaxed">
                我們採取多元評選機制<br />
                確保每位申請者都能被公平看見
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="relative mt-16 max-w-7xl mx-auto px-6">
        <div className="bg-white/95 backdrop-blur-sm rounded-3xl p-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-8">評選流程</h3>
          <div className="grid grid-cols-4 gap-8 mb-12">
            {process.map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-[#F4A261] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-white">{item.step}</span>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h4>
                <p className="text-sm text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>

          <div className="border-t border-gray-200 pt-8">
            <h4 className="text-xl font-bold text-gray-900 mb-6">評審團成員</h4>
            <div className="flex flex-wrap gap-3">
              {reviewers.map((reviewer, index) => (
                <div key={index} className="px-5 py-2.5 bg-[#F5F1E8] rounded-full">
                  <span className="text-sm font-medium text-gray-700">{reviewer}</span>
                </div>
              ))}
            </div>
            <p className="text-sm text-gray-600 mt-6">
              確保評選兼顧專業、公益價值與青年實際需求
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
